// features/finances/components/PresupuestoTab.tsx
// FINANZAS › PRESUPUESTO con dos apartados (B2 ampliado, 25-oct-2026): «Gastos» (B2, 15-oct) e «Ingresos» (objetivo por
// categoría × mes). El apartado se recuerda en la URL (?tab=presupuesto&pres=ingresos) para poder enlazarlo.
import { useSearchParams } from 'react-router-dom';
import PresupuestoGastosPanel from './PresupuestoGastosPanel';
import PresupuestoIngresosPanel from './PresupuestoIngresosPanel';

export default function PresupuestoTab() {
  const [sp, setSp] = useSearchParams();
  const sub = sp.get('pres') === 'ingresos' ? 'ingresos' : 'gastos';
  const elegir = (k: 'gastos' | 'ingresos') => { const n = new URLSearchParams(sp); if (k === 'gastos') n.delete('pres'); else n.set('pres', k); setSp(n, { replace: true }); };
  return (
    <div>
      <div className="mb-4 inline-flex rounded-lg border border-line bg-surface p-1" role="tablist" aria-label="Presupuesto">
        {([['gastos', 'Gastos'], ['ingresos', 'Ingresos']] as const).map(([k, label]) => (
          <button key={k} role="tab" aria-selected={sub === k} onClick={() => elegir(k)}
            className={`rounded-md px-4 py-1.5 text-sm font-medium transition ${sub === k ? 'bg-accent text-on-accent shadow-sm' : 'text-content-2 hover:text-content'}`}>
            {label}
          </button>
        ))}
      </div>
      {sub === 'ingresos' ? <PresupuestoIngresosPanel /> : <PresupuestoGastosPanel />}
    </div>
  );
}
